import f from "./ghl-ui.es1589.js";
import m from "./ghl-ui.es1590.js";
import n from "./ghl-ui.es1586.js";
import b from "./ghl-ui.es1587.js";
import u from "./ghl-ui.es1588.js";
import s from "./ghl-ui.es1591.js";
import { Parser as c } from "./ghl-ui.es1670.js";
import { dayPeriodEnumToHours as p } from "./ghl-ui.es1671.js";
var M = /* @__PURE__ */ function(d) {
  b(o, d);
  var a = u(o);
  function o() {
    var e;
    f(this, o);
    for (var t = arguments.length, i = new Array(t), r = 0; r < t; r++)
      i[r] = arguments[r];
    return e = a.call.apply(a, [this].concat(i)), s(n(e), "priority", 80), s(n(e), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), e;
  }
  return m(o, [{
    key: "parse",
    value: function(t, i, r) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return r.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return r.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return r.dayPeriod(t, {
            width: "wide",
            context: "formatting"
          }) || r.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(t, i, r) {
      return t.setUTCHours(p(r), 0, 0, 0), t;
    }
  }]), o;
}(c);
export {
  M as AMPMMidnightParser
};
